export class IError {
	header: string;
	description: string;

	constructor() {
		this.header = '';
		this.description = '';
	}
}
